module.exports = __webpack_public_path__ + "img/capture_boursedechange.5ed85c61.png";